import Vue from 'vue';
import qs from 'qs';
import axios from '../plugins/axios';

const prefix = '/api';

const api = {
  getPublicKey() {
    return axios.get(`${prefix}/rsa/public-key`);
  },
  // 密码更新
  passwordupdate: {
    /**
     * 密码校验
     * @param {Object} password - 校验的密码字符串
     * @returns {Promise} Promise实例
     */
    validpassword(password) {
      return axios.post(`${prefix}/passwordupdate/validpassword?password=${encodeURIComponent(password)}`);
    },
    /**
     * 更新密码
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    updatePassword(params) {
      return axios.post(`${prefix}/passwordupdate/UpdatePassword`, qs.stringify(params));
    },
    /**
     * 登录
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    login(params) {
      return axios.post(`${prefix}/passwordupdate/Login`, qs.stringify(params));
    },
    /**
     * 当前用户信息
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    currentUser() {
      return axios.get(`${prefix}/passwordupdate/CurrentUser`);
    },
  },
  // 手机号更新
  mobileUpdate: {
    /**
     * 当前用户信息
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    currentUser(params) {
      return axios.get(`${prefix}/mobileupdate/CurrentUser`, {
        params,
      });
    },

    /**
     * 发送短信验证码
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    sendMessage(params) {
      return axios.post(`${prefix}/mobileupdate/smsCaptcha`, params);
    },

    /**
     * 登录
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    login(params) {
      return axios.post(`${prefix}/mobileupdate/Login`, qs.stringify(params));
    },

    /**
     * 更新手机号
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    updateMobile(params) {
      return axios.post(`${prefix}/mobileupdate/UpdateMobile`, qs.stringify(params));
    },
  },

  // 手机号认证
  mobileAuth: {
    /**
     * 当前用户信息
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    currentUser(params) {
      return axios.get(`${prefix}/adpasscode/CurrentUser`, {
        params,
      });
    },

    /**
     * 发送短信验证码
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    sendMessage(params) {
      return axios.post(`${prefix}/adpasscode/sendMessageToMobile`, params);
    },

    /**
     * 登录
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    login(params) {
      return axios.post(`${prefix}/adpasscode/Login`, params);
    },

    /**
     * 重置密码
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    resetPassword(params) {
      return axios.post(`${prefix}/adpasscode/ResetPassword`, params);
    },

    /**
     * 解锁帐号
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    unlockAccount(params) {
      return axios.post(`${prefix}/adpasscode/UnlockAccount`, params);
    },
  },

  // 邮箱认证
  emailAuth: {
    /**
     * 当前用户信息
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    currentUser(params) {
      return axios.get(`${prefix}/adpassemail/CurrentUser`, {
        params,
      });
    },

    /**
     * 发送邮箱验证码
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    sendMessage(params) {
      return axios.post(`${prefix}/adpassemail/sendMessageToEmail`, params);
    },

    /**
     * 登录
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    login(params) {
      return axios.post(`${prefix}/adpassemail/Login`, params);
    },

    /**
     * 重置密码
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    resetPassword(params) {
      return axios.post(`${prefix}/adpassemail/ResetPassword`, params);
    },

    /**
     * 解锁帐号
     * @param {Object} params - 请求参数
     * @returns {Promise} Promise实例
     */
    unlockAccount(params) {
      return axios.post(`${prefix}/adpassemail/UnlockAccount`, params);
    },
  },
  getMobile(encryptionCode) {
    return axios.get(`${prefix}/adpwreset/getmobile?account=${encryptionCode}`);
  },
};

Vue.api = api;
Vue.prototype.$api = api;

export default api;
